import React from "react"
import {
  Navigate,
  useLocation,
  useParams,
  useSearchParams
} from "react-router-dom"

import { connect, isInPlaceEditingActive } from "scrivito"
import { PRODUCT } from "shared/constants/permalinks"
import { NoComponentPage } from "shared/ui/no-component-page/NoComponentPage"

import { useVariantKey } from "entities/products/model/useVariantKey"

import { ProductPageDefault } from "./ProductPage"
import { useProductPageModel } from "./model/useProductPageModel"

export const ProductPageConnector = React.memo(
  (props: { productType?: string }) => {
    const { variantKey, locale } = useParams()
    const { hash } = useLocation()
    const { attributes, productType } = useVariantKey(variantKey || null)
    const [searchParams] = useSearchParams()

    if (props.productType) {
      return (
        <ProductPageConnectorInnerConnectedComponent
          productType={props.productType}
        />
      )
    }

    if (attributes.length > 1 && isInPlaceEditingActive()) {
      return <NoComponentPage />
    }

    if (attributes.length > 1) {
      searchParams.set("variantKey", variantKey || "")
      return (
        <Navigate
          to={{
            pathname: `/${locale}/${PRODUCT}/${productType}`,
            search: searchParams.toString(),
            hash
          }}
          replace
        />
      )
    }

    return productType ? (
      <ProductPageConnectorInnerConnectedComponent productType={productType} />
    ) : null
  }
)

function ProductPageConnectorInnerComponent({
  productType
}: {
  productType: string
}) {
  return <ProductPageDefault {...useProductPageModel({ productType })} />
}

const ProductPageConnectorInnerConnectedComponent = connect(
  ProductPageConnectorInnerComponent
)
